<template>
  <div class="mt-component-form">
    <vs-row class="my-4">
      <h5 style="align-self: center"><i class="dot"></i>일반 검진</h5>
      <div class="flex items-center gap-2 ml-auto">
        <vs-button color="secondary" type="flat" @click="fold = false"><img src="@/assets/images/icon/IconTriangleDown.svg" class="inline-block align-middle" /> 모두펼치기</vs-button>
        <hr class="-mx-2" style="height: 20px; border-width: 1px; border-color: #6670cb; border-left: 0" />
        <vs-button color="secondary" type="flat" @click="fold = true"> <img src="@/assets/images/icon/IconTriangleDown.svg" class="inline-block align-middle" style="transform: rotate(180deg)" /> 모두접기</vs-button>
        <vs-button v-if="!isPrint && !isReadonly" color="secondary" type="border" @click="handleAddRow">항목추가</vs-button>
        <vs-button v-if="!isPrint && !isReadonly" color="secondary" @click="handleRemoveRow" :disabled="equipmentList.filter((item) => item.is_checked).length === 0">선택삭제</vs-button>
      </div>
    </vs-row>

    <!-- row -->
    <div v-show="!fold">
      <div class="grid mb-6 data-row" :style="{ gridTemplateColumns: `${isPrint || isReadonly ? '' : '36px'} 1fr` }" v-for="row in equipmentList" :key="row.id">
        <div v-if="!isPrint && !isReadonly" class="none-border-center th write361">
          <vs-checkbox v-model="row.is_checked"></vs-checkbox>
        </div>
        <div>
          <!--첫번째 줄-->
          <div class="grid" style="grid-template-columns: 1fr 1fr 1fr 1fr 1fr">
            <div class="th">검진일<br />/ 검진병원</div>
            <div class="th">건강진단 건강관리구분 판정</div>
            <div class="th">검진소견</div>
            <div class="th">사후관리조치</div>
            <div class="th">업무적합성 평가</div>

            <div class="td">
              <div style="margin-bottom: 7px">
                <p v-if="isPrint" class="print-input">{{ row["검진일"] }}</p>
                <date-selector v-else class="w-full" v-model="row['검진일']" placeholder="날짜" :readonly="isReadonly || isPrint"></date-selector>
              </div>
              <div>
                <p v-if="isPrint" class="print-input">{{ row["검진병원"] }}</p>
                <ml-input v-else v-model="row['검진병원']" class="w-full" />
              </div>
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["판정"] }}</p>
              <multiselect v-else :readonly="isReadonly || isPrint" :options="determinationOptions" v-model="row['판정']" :multiple="true" placeholder="" class="w-full" />

              <!-- <vs-select v-else :disabled="isReadonly || isPrint" v-model="row['판정']" autocomplete class="w-full flex-1">
                <vs-select-item v-for="option of determinationOptions" :text="option" :value="option" :key="option" />
              </vs-select> -->
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-textarea">{{ row["검진소견"] }}</p>
              <ml-textarea v-else v-model="row['검진소견']" class="w-full h-full" height="100%" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-textarea">{{ row["사후관리조치"] }}</p>
              <ml-textarea v-else v-model="row['사후관리조치']" class="w-full h-full" height="100%" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["업무적합성평가"] ? row["업무적합성평가"].join(", ") : "" }}</p>
              <multiselect v-else :options="['가', '나', '다', '라']" v-model="row['업무적합성평가']" :multiple="true" placeholder="" class="w-full" />
            </div>
          </div>

          <!--두번째 줄-->
          <div class="grid" style="grid-template-columns: repeat(7, 1fr)">
            <div class="th" style="grid-row: 1/3">상담기준</div>
            <div class="th">고혈압</div>
            <div class="th">당뇨</div>
            <div class="th">이상지질혈증</div>
            <div class="th">간장질환</div>
            <div class="th">뇌심질환 발병위험도</div>
            <div class="th">기타</div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["고혈압"] }}</p>
              <ml-input v-else v-model="row['고혈압']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["당뇨"] }}</p>
              <ml-input v-else v-model="row['당뇨']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["이상지질혈증"] }}</p>
              <ml-input v-else v-model="row['이상지질혈증']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["간장질환"] }}</p>
              <ml-input v-else v-model="row['간장질환']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["뇌심질환발병위험도"] }}</p>
              <ml-input v-else v-model="row['뇌심질환발병위험도']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["상담기준기타"] }}</p>
              <ml-input v-else v-model="row['상담기준기타']" class="w-full" />
            </div>
          </div>

          <!--세번째 줄-->
          <div class="grid" style="grid-template-columns: repeat(14, 1fr)">
            <div class="th">신장</div>
            <div class="th">체중</div>
            <div class="th">허리둘레</div>
            <div class="th">혈액형</div>
            <div class="th">시력</div>
            <div class="th">색신</div>
            <div class="th">청력</div>
            <div class="th">요당</div>
            <div class="th">요단백</div>
            <div class="th">요잠혈</div>
            <div class="th">요ph</div>
            <div class="th">심전도</div>
            <div class="th">흉부방사선</div>
            <div class="th">폐기능</div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["신장"] }}</p>
              <ml-input v-else v-model="row['신장']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["체중"] }}</p>
              <ml-input v-else v-model="row['체중']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["허리둘레"] }}</p>
              <ml-input v-else v-model="row['허리둘레']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["혈액형"] }}</p>
              <ml-input v-else v-model="row['혈액형']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["시력"] }}</p>
              <ml-input v-else v-model="row['시력']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["색신"] }}</p>
              <ml-input v-else v-model="row['색신']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["청력"] }}</p>
              <ml-input v-else v-model="row['청력']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["요당"] }}</p>
              <ml-input v-else v-model="row['요당']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["요단백"] }}</p>
              <ml-input v-else v-model="row['요단백']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["요잠혈"] }}</p>
              <ml-input v-else v-model="row['요잠혈']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["요ph"] }}</p>
              <ml-input v-else v-model="row['요ph']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["심전도"] }}</p>
              <ml-input v-else v-model="row['심전도']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["흉부방사선"] }}</p>
              <ml-input v-else v-model="row['흉부방사선']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["폐기능"] }}</p>
              <ml-input v-else v-model="row['폐기능']" class="w-full" />
            </div>
          </div>

          <!--네번째 줄-->
          <div class="grid" style="grid-template-columns: repeat(14, 1fr)">
            <div class="th">BP</div>
            <div class="th">혈당(신전)</div>
            <div class="th">AST(GOT)</div>
            <div class="th">ALT(GPT)</div>
            <div class="th">GPT</div>
            <div class="th">TC</div>
            <div class="th">TG</div>
            <div class="th">HDL</div>
            <div class="th">LDL</div>
            <div class="th">혈색소</div>
            <div class="th">당화혈색소</div>
            <div class="th">BUN</div>
            <div class="th">Cr</div>
            <div class="th">기타</div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["BP"] }}</p>
              <ml-input v-else v-model="row['BP']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["혈당"] }}</p>
              <ml-input v-else v-model="row['혈당']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["AST"] }}</p>
              <ml-input v-else v-model="row['AST']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["ALT"] }}</p>
              <ml-input v-else v-model="row['ALT']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["GPT"] }}</p>
              <ml-input v-else v-model="row['GPT']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["TC"] }}</p>
              <ml-input v-else v-model="row['TC']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["TG"] }}</p>
              <ml-input v-else v-model="row['TG']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["HDL"] }}</p>
              <ml-input v-else v-model="row['HDL']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["LDL"] }}</p>
              <ml-input v-else v-model="row['LDL']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["혈색소"] }}</p>
              <ml-input v-else v-model="row['혈색소']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["당화혈색소"] }}</p>
              <ml-input v-else v-model="row['당화혈색소']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["BUN"] }}</p>
              <ml-input v-else v-model="row['BUN']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["Cr"] }}</p>
              <ml-input v-else v-model="row['Cr']" class="w-full" />
            </div>
            <div class="td">
              <p v-if="isPrint" class="print-input">{{ row["기타"] }}</p>
              <ml-input v-else v-model="row['기타']" class="w-full" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector.vue";
import Multiselect from "vue-multiselect";

export default {
  name: "General",
  components: { DateSelector, Multiselect },
  props: {
    list: Array,
    isPrint: Boolean,
    isReadonly: Boolean,
    determinationOptions: {
      type: Array,
      default: () => ["C2", "D2"],
    },
  },
  watch: {
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value && value.length > 0) {
          // id 값이 빠져있다면 추가한다
          if (Array.isArray(value)) {
            for (let i = 0; i < value.length; i++) {
              if (!value[i].id) {
                value[i].id = this.generateRandomId();
              }
            }
          }

          this.equipmentList = value;
        }
      },
    },
    equipmentList: {
      handler() {
        this.updateList();
      },
    },
  },
  methods: {
    checkForm(value, indexRow, text) {
      if (value.target.checked) {
        this.$emit("update-list-check", indexRow - 1, text);
      } else {
        this.$emit("update-list-check", indexRow - 1, "");
      }
    },
    // 항목추가
    handleAddRow() {
      this.equipmentList.unshift(this.getEmptyRow());
      this.updateList();
    },
    // 선택삭제
    handleRemoveRow() {
      for (let i = 0; i < this.equipmentList.length; i++) {
        if (this.equipmentList[i].is_checked) {
          this.equipmentList.remove(this.equipmentList[i]);
          i = -1;
        }
      }

      this.equipAllCheck = false;
      this.updateList();
    },
    // 일괄 체크
    changeAllCheck() {
      for (const data of this.equipmentList) {
        data.is_checked = this.equipAllCheck;
      }
    },
    // update
    updateList() {
      this.$emit("updateList", this.equipmentList);
    },
    getEmptyRow() {
      return {
        id: this.generateRandomId(),
        검진일: "",
        검진병원: "",
        업무적합성평가: [],
        검진소견: "",
        사후관리조치: "",
        판정: "",
        고혈압: "",
        당뇨: "",
        이상지질혈증: "",
        간장질환: "",
        뇌심질환발병위험도: "",
        상담기준기타: "",
        신장: "",
        체중: "",
        허리둘레: "",
        혈액형: "",
        시력: "",
        색신: "",
        청력: "",
        요당: "",
        요단백: "",
        요잠혈: "",
        요ph: "",
        심전도: "",
        흉부방사선: "",
        폐기능: "",
        BP: "",
        혈당: "",
        AST: "",
        ALT: "",
        GPT: "",
        TC: "",
        TG: "",
        HDL: "",
        LDL: "",
        혈색소: "",
        당화혈색소: "",
        BUN: "",
        Cr: "",
        기타: "",
        is_checked: false,
      };
    },
    generateRandomId() {
      return Math.random().toString(36).substr(2, 16);
    },
  },
  data() {
    return {
      fold: false,
      equipAllCheck: false,
      equipmentList: [],
    };
  },
};
</script>
<style>
.write361 .vs-checkbox {
  margin-right: 0 !important;
}
</style>
<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.label-text {
  width: 127px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 25px;
}
.vs-checkbox-default {
  margin: 0;
}
.ml-group-checkBox ~ .ml-group-checkBox {
  margin: 0;
}

/* Table */
.row-header {
  background-color: $bg;
  text-align: center;

  &__checkbox-title {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: $border;
    width: 100%;
  }
  &__checkboxs {
    display: flex;
    height: 50%;
    width: 100%;
    div {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    div:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
}
.row-header__item {
  border: $border;
  border-left: none;
  border-right: none;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.row-header__item.item-col {
  flex-direction: column;
}
.row-header__item:last-child {
  border-right: none;
}

.none-border-center {
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* row data */
.row-content {
  border-bottom: $border;
  &__title {
    background-color: $bg;
    height: 100%;
  }
  &__body {
  }
}
.row-content__body-item {
  .item-content {
    padding: 15px;
    border-left: $border;

    pre {
      font-family: "Noto Sans KR", "Montserrat", Helvetica, Arial, sans-serif;
      white-space: pre-wrap;
    }
  }
  .item-box {
    border-left: $border;
    border-right: $border;
    display: flex;
    .item-box-check {
      flex: 1;
      justify-content: center !important;
    }
    .item-box-check:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
  .item-area {
    padding: 5px;
    align-self: center;
  }
}
.row-content__body-item ~ .row-content__body-item {
  border-top: $border;
}
.vs-component.vs-con-textarea.vs-textarea-primary {
  margin: 0;
}
.row-content-none-data {
  height: 120px;
  border-bottom: $border;
  display: flex;
  justify-content: center;
  align-items: center;
}
.th {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 54px;
  background-color: #f9f9f9;
  outline: $border;
  text-align: center;
}
.td {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 7px;
  outline: $border;
}
</style>
